import { render, staticRenderFns } from "./entityItem.vue?vue&type=template&id=0f49e680&scoped=true"
import script from "./entityItem.vue?vue&type=script&lang=js"
export * from "./entityItem.vue?vue&type=script&lang=js"
import style0 from "./entityItem.vue?vue&type=style&index=0&id=0f49e680&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f49e680",
  null
  
)

export default component.exports